import { render } from "./FinishSignup.vue?vue&type=template&id=18ff114c&scoped=true"
import script from "./FinishSignup.vue?vue&type=script&lang=js"
export * from "./FinishSignup.vue?vue&type=script&lang=js"

import "./FinishSignup.vue?vue&type=style&index=0&id=18ff114c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ff114c"]])

export default __exports__